import { indexBy } from 'remeda';

export const toDict = <T extends { url: string }>(
  items: T[] = [],
  // TODO: might be cool to allow only keys of T which values are strings or numbers
  keyProp: keyof T = 'url'
) => indexBy(items, item => String(item[keyProp]));
